"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEMS_OUTSIDE_VIEWPORT = exports.TABLE_ROW_HEIGHT = exports.COLUMN_WIDTH_MULTIPLIER = exports.SEARCH_TIMEOUT = exports.LANGUAGE_EXPIRES = exports.DEFAULT_LANGUAGE = void 0;
// Language
exports.DEFAULT_LANGUAGE = 'en';
exports.LANGUAGE_EXPIRES = 24 * 365;
// Search
exports.SEARCH_TIMEOUT = 1000;
// SOK Virtualize table default values
exports.COLUMN_WIDTH_MULTIPLIER = 0.5;
exports.TABLE_ROW_HEIGHT = 40;
exports.ITEMS_OUTSIDE_VIEWPORT = 15;
